import React, { createContext, useContext, useState } from "react";

const WizardContext = createContext(null);

export function WizardProvider({ children }) {
  const [country, _setCountry] = useState({
    code: "TR", name: "Türkiye", standard: "TS 825:2024",
    region: "Europe", lat: 38.9637, lon: 35.2433,
  });
  const [city, _setCity] = useState(null);            // string | null
  const [district, _setDistrict] = useState(null);    // string | null
  const [climate, setClimate] = useState(null);       // { id, name, parent }
  const [space, setSpace] = useState(null);           // INSULATION_SPACES entry
  const [insCategory, setInsCategory] = useState(null); // ISIMAL | SES | SU | YANGIN | ELEKTRIK
  const [insType, setInsType] = useState(null);       // INSULATION_TYPES entry (Material)
  const [material, setMaterial] = useState(null);     // PRESET_MATERIALS entry
  const [dimensions, setDimensions] = useState({ width: 1.0, length: 1.0, height: 2.8 });

  // Wrapped setters so changing the parent resets dependent children
  const setCountry = (c) => {
    _setCountry(c);
    _setCity(null);
    _setDistrict(null);
  };
  const setCity = (c) => {
    _setCity(c);
    _setDistrict(null);
  };
  const setDistrict = (d) => _setDistrict(d);

  const value = {
    country, setCountry,
    city, setCity,
    district, setDistrict,
    climate, setClimate,
    space, setSpace,
    insCategory, setInsCategory,
    insType, setInsType,
    material, setMaterial,
    dimensions, setDimensions,
  };

  return <WizardContext.Provider value={value}>{children}</WizardContext.Provider>;
}

export function useWizard() {
  const ctx = useContext(WizardContext);
  if (!ctx) throw new Error("useWizard must be used within WizardProvider");
  return ctx;
}
